import { render, staticRenderFns } from "./YourNetwork.vue?vue&type=template&id=85ed409c&scoped=true&"
import script from "./YourNetwork.vue?vue&type=script&lang=js&"
export * from "./YourNetwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ed409c",
  null
  
)

export default component.exports